import * as d3 from 'd3';

export function drawTopTilt(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  lineColor = 'red',
  direction = 'down' // 'down' (default) or 'up'
) {
  const xLeft = x;
  const xRight = x + width;
  const yTop = y;
  const yBottom = y + height;
  const xMiddle = x + width / 2;

  let x1Left, y1Left, x2Left, y2Left;
  let x1Right, y1Right, x2Right, y2Right;

  if (direction === 'up') {
    // Invert V to ^
    x1Left = xLeft;
    y1Left = yBottom;
    x2Left = xMiddle;
    y2Left = yTop;

    x1Right = xRight;
    y1Right = yBottom;
    x2Right = xMiddle;
    y2Right = yTop;
  } else {
    // Default "V"
    x1Left = xLeft;
    y1Left = yTop;
    x2Left = xMiddle;
    y2Left = yBottom;

    x1Right = xRight;
    y1Right = yTop;
    x2Right = xMiddle;
    y2Right = yBottom;
  }

  // Left line
  svg.append('line')
    .attr('x1', x1Left)
    .attr('y1', y1Left)
    .attr('x2', x2Left)
    .attr('y2', y2Left)
    .attr('stroke', lineColor)
    .attr('stroke-width', 1)
    .attr('stroke-dasharray', '6,5');

  // Right line
  svg.append('line')
    .attr('x1', x1Right)
    .attr('y1', y1Right)
    .attr('x2', x2Right)
    .attr('y2', y2Right)
    .attr('stroke', lineColor)
    .attr('stroke-width', 1)
    .attr('stroke-dasharray', '6,5');
}

export function drawTopTilt1(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  lineColor = 'red'
) {
  const xLeft = x;
  const xRight = x + width;
  const yTop = y;
  const yBottom = y + height;
  const xBottomMiddle = x + width / 2;

  // Line from top-left to bottom-middle
  svg.append('line')
    .attr('x1', xLeft)
    .attr('y1', yTop)
    .attr('x2', xBottomMiddle)
    .attr('y2', yBottom)
    .attr('stroke', lineColor)
    .attr('stroke-width', 1)
    .attr('stroke-dasharray', '6,4');

  // Line from top-right to bottom-middle
  svg.append('line')
    .attr('x1', xRight)
    .attr('y1', yTop)
    .attr('x2', xBottomMiddle)
    .attr('y2', yBottom)
    .attr('stroke', lineColor)
    .attr('stroke-width', 1)
    .attr('stroke-dasharray', '6,4');
}